import "./LoginDesktopView.scss";

const LoginDesktopView = ({
    logo_svg,
    email,
    password,
    errorMsg,
    onEmailChange,
    onPasswordChange,
    onSubmit
}) => {
    return (
        <>
            <div className='left-panel' />

            <div className='right-panel'>
                <div className='content-container'>
                    <div className='logo-container'>
                        <img className='login-logo' src={logo_svg} alt="logo" />
                        <h1 className='sign-in-text-container'>
                            HorizonView
                        </h1>
                    </div>

                    <h2 className='sub-text'>
                        Effortlessly oversee medical devices from any location, on any screen,
                        with HorizonView—an intelligent solution designed for seamless remote
                        monitoring of healthcare equipment.
                    </h2>

                    <div className='login-form-container'>
                        <div className='email-container'>
                            <input
                                className='login-input email'
                                type='email'
                                placeholder='Email ID'
                                value={email || ""}
                                onChange={onEmailChange}
                            />
                        </div>

                        <div className='password-container'>
                            <input
                                className='login-input password'
                                type="password"
                                placeholder='Password'
                                value={password || ""}
                                onChange={onPasswordChange}
                            />
                        </div>

                        <div className='error-msg'>
                            {errorMsg}
                        </div>

                        <div className='sign-in-botton-container'>
                            <button
                                className='sign-in sign-in-botton'
                                onClick={onSubmit}
                            >
                                Sign In
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default LoginDesktopView;
